import React from 'react';
import {Container} from 'reactstrap';
import {connect, ConnectedProps} from 'react-redux';
import {IReduxStoreState} from '@src/@interfaces';
import classnames from '@src/helpers/classnames';
import config from '@src/helpers/config';
import WebSocketConnectionIndicator from '../../../WebSocketConnectionIndicator/WebSocketConnectionIndicator';

export class Footer extends React.Component<ConnectedProps<typeof connector> & {
    footerRef?: React.RefObject<HTMLDivElement>,
    style?: React.CSSProperties,
}> {
    render() {
        const currentYear = new Date().getFullYear();

        return <footer
                ref={this.props.footerRef}
                className={classnames('footer', {
                    'footer--sidebar-collapsed': this.props.desktopSidebarSize === 'small',
                    'footer--mobile-sidebar-open': this.props.isMobileVersion && this.props.mobileSidebarIsOpen,
                })}
                style={this.props.style}
        >
            <Container fluid className="row align-items-center">
                <div className="col-12 col-md-auto">
                    {currentYear === 2022 ? null : '2022 - '}{currentYear} © Rights not reserved
                </div>
                <div className="col-12 col-md-auto ms-auto text-md-end">
                    <WebSocketConnectionIndicator className="me-2"/>
                    NexusCRM@<span className="small">{config('client.app-version')}</span>
                </div>
            </Container>
        </footer>;
    }
}

export const connector = connect((state: IReduxStoreState) => ({
    desktopSidebarSize: state.theme.sidebar.desktop.size,
    isMobileVersion: state.theme.isMobileVersion,
    mobileSidebarIsOpen: state.theme.sidebar.mobile.open,
}));

export default connector(Footer);
